<div class="container">
  <div class="top">
    <img src="assets/sad-yooga.svg" alt="">
    <h3>Você tem certeza que <br /> quer tirar a taxa?</h3>
    <p>Essa taxa ajuda a complementar <br /> a renda do garçom no final do mês.</p>
  </div>
  <div class="buttons">
    <yoo-button
      primary
      large
      emphasis
      iconLeft="smileFace"
      [block]="true"
      (click)="keepTax()"
    >
      <span>Voltar com a taxa</span>
    </yoo-button>
    <yoo-button
      critical
      large
      plain
      iconLeft="sadFace"
      [block]="true"
      (click)="removeTax()"
    >
      <span>Tirar taxa</span>
    </yoo-button>
  </div>
</div>